var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolScatterHaikei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 600,
    fill: "#FCAF3C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#C62368"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -131.2L29.5 -40.5L124.8 -40.5L47.7 15.5L77.1 106.1L0 50.1L-77.1 106.1L-47.7 15.5L-124.8 -40.5L-29.5 -40.5Z",
    transform: "translate(262 380)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -41.5L9.3 -12.8L39.5 -12.8L15.1 4.9L24.4 33.6L0 15.9L-24.4 33.6L-15.1 4.9L-39.5 -12.8L-9.3 -12.8Z",
    transform: "translate(748 472)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -103.8L23.3 -32.1L98.7 -32.1L37.7 12.3L61 84L0 39.7L-61 84L-37.7 12.3L-98.7 -32.1L-23.3 -32.1Z",
    transform: "translate(35 102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -73.6L16.5 -22.7L70 -22.7L26.7 8.7L43.3 59.6L0 28.1L-43.3 59.6L-26.7 8.7L-70 -22.7L-16.5 -22.7Z",
    transform: "translate(777 53)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -76.5L17.2 -23.6L72.7 -23.6L27.8 9L44.9 61.8L0 29.2L-44.9 61.8L-27.8 9L-72.7 -23.6L-17.2 -23.6Z",
    transform: "translate(399 28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -45.3L10.2 -14L43.1 -14L16.5 5.3L26.6 36.7L0 17.3L-26.6 36.7L-16.5 5.3L-43.1 -14L-10.2 -14Z",
    transform: "translate(57 589)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolScatterHaikei);
export default __webpack_public_path__ + "static/media/symbol-scatter-haikei.627cd29270aa30f7c35df6df2f561665.svg";
export { ForwardRef as ReactComponent };